var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueRouteSectionFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M20 0c2.206 0 4 1.794 4 4s-1.794 4-4 4c-1.79 0-3.296-1.187-3.804-2.81L16.142 5H8c-.496.006-3 .177-3 3 0 2.74 2.359 2.982 2.957 2.999l.049.001H16c1.729 0 5 1.045 5 5 0 3.865-3.124 4.951-4.88 4.998L16 21H7.858c-.447 1.721-2 3-3.858 3-2.206 0-4-1.794-4-4s1.794-4 4-4c1.79 0 3.296 1.186 3.804 2.81l.054.19H16c.496-.006 3-.177 3-3 0-2.74-2.359-2.982-2.957-2.999L15.994 13H8c-1.729 0-5-1.045-5-5 0-3.865 3.124-4.951 4.88-4.998L8 3h8.142c.447-1.72 2-3 3.858-3zm3 19a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 1-1zM4 18c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM20 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM1 0h3a1 1 0 0 1 .117 1.993L4 2H2v2a1 1 0 0 1-1.993.117L0 4V1A1 1 0 0 1 .883.007L1 0h3z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRouteSectionFocus);
export default __webpack_public_path__ + "static/media/blue-route-section-focus.116e8aebd170fe6a67636da01a974627.svg";
export { ForwardRef as ReactComponent };